import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "classNames", "styles", "unstyled", "className", "href", "radius", "backgroundColor", "cutout"];
import { jsx } from 'react/jsx-runtime';
import { Button as Button$1 } from '@mantine/core';
import useStyles from './Button.styles.js';
var Button = function Button(_ref) {
  var children = _ref.children,
    classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    className = _ref.className,
    href = _ref.href,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 0 : _ref$radius,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? "#5CCBCB" : _ref$backgroundColor,
    _ref$cutout = _ref.cutout,
    cutout = _ref$cutout === void 0 ? "none" : _ref$cutout,
    props = _objectWithoutProperties(_ref, _excluded);
  var _a;
  props.variant = ((_a = props.variant) != null ? _a : "default") === "default" ? "filled" : props.variant;
  var _useStyles = useStyles({
      backgroundColor: backgroundColor
    }, {
      name: "Button",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var cutoutClass = classes.cutoutBottom;
  switch (cutout) {
    case "top":
      cutoutClass = classes.cutoutTop;
      break;
    case "bottom":
      cutoutClass = classes.cutoutBottom;
      break;
    case "none":
      cutoutClass = classes.cutoutNone;
      break;
  }
  return /* @__PURE__ */jsx(Button$1, _objectSpread(_objectSpread({
    component: href ? "a" : "button",
    href: href,
    classNames: {
      root: classes.root,
      label: classes.label,
      inner: classes.inner,
      icon: classes.icon,
      leftIcon: classes.leftIcon,
      rightIcon: classes.rightIcon
    },
    className: cx(cutoutClass),
    radius: radius
  }, props), {}, {
    children: children
  }));
};
export { Button };